
import { defineComponent, PropType } from 'vue';
import { B2BRequestAccessTileModel } from '@/types/B2BcontentServerContract';
import ProfileRequestAccess from '@/b2b/request-access/ui/ProfileRequestAccess.vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';

export default defineComponent({
    name: 'B2BRequestAccessTile',
    components: { BlockMaxWidthHandler, ProfileRequestAccess },
    props: {
        content: {
            type: Object as PropType<B2BRequestAccessTileModel>,
            required: true,
        },
    },
});
